"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCamelCase = void 0;
var toCamelCase = function (errorKey) {
    return errorKey
        .split(/[.-]/)
        .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
        .join(' ');
};
exports.toCamelCase = toCamelCase;
//# sourceMappingURL=errorsUtils.js.map